module.exports = __webpack_public_path__ + "img/banner3_4_jp.4737c20b.png";